import React, { useEffect, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import Header from 'components/Header';
import Footer from 'components/Footer';

import themes from '@themes';
import { getToken } from '@api';
import { getUserAction } from '@services/user/actions';
import { setRefreshTokenFailed } from '@services/app/actions';
import { unregister } from './serviceWorker';

import GlobalStyle from './styles/global';

import Routes from './Routes';

const theme = 'main';

const App = ({ history, location }) => {
	const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
	const dispatch = useDispatch();

	const [loading, setLoading] = useState(true);

	const checkUser = async () => {
		const hasToken = await getToken();
		if (hasToken) {
			dispatch(
				getUserAction(() => {
					setLoading(false);
				}),
			);
		} else {
			setLoading(false);
		}
	};

	useEffect(() => {
		// if location state has value and noClose eq false then remove state
		if (!location.state?.noClose) {
			location.state = null;
			history.replace(location, null);
		}

		checkUser();
	}, []);

	useEffect(() => {
		const isHome = location.pathname === '/';
		if (isLoggedIn && isHome) {
			history.push('/menu');
		}
	}, [isLoggedIn]);

	// after try refresh token and failed, redirect to home
	const refreshTokenFailed = useSelector(
		(state) => state.app.refreshTokenFailed,
	);
	useEffect(() => {
    console.log("updated")
		if (refreshTokenFailed) {
			dispatch(setRefreshTokenFailed(false));
			history.replace('/', null);
		}
	}, [refreshTokenFailed]);

	return (
		<ThemeProvider theme={themes[theme]}>
			<GlobalStyle />

			{loading ? (
				<div />
			) : (
				<div>
					<Header />
					<Routes />
					<Footer />
				</div>
			)}
		</ThemeProvider>
	);
};

const areEqual = () => true;

unregister();
export default withRouter(memo(App, areEqual));
